export default function(x) {
  return function constant() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-shape/src/constant.js
// module id = 16
// module chunks = 0